<ng-container
  *ngIf="
    (isLoggedIn$ | async) && (userAccountService.getEbActiveUserData() | async) as user;
    else login
  "
>
  <div class="eb-login__greet" [attr.data-rendermode]="reportRenderMode('loggedIn')">
    {{ 'miniLogin.userGreeting' | cxTranslate: { name: user.name } }}
  </div>
  <cx-page-slot id="account-nav" position="HeaderLinks"></cx-page-slot>
</ng-container>

<ng-template #login>
  <button
    class="eb-login__login"
    data-cy="login-button"
    (click)="loginWithSapIDP()"
    [attr.data-rendermode]="reportRenderMode('anonymous')"
  >
    {{ 'miniLogin.signIn' | cxTranslate }}
  </button>
</ng-template>
